import { useEffect, useMemo } from 'react';

import { useQuery } from '@apollo/client';
import { useMe } from '@crehana/auth';
import { useRouter } from 'next/router';

import useLeadership from '@/views/AdminDashboard/hooks/useLeadership';

import GetTeamsByLeaderQuery from './graphql/GetTeamsByLeader.v4.b2b.graphql';
import type {
  GetTeamsByLeader,
  GetTeamsByLeaderVariables,
} from './graphql/types/GetTeamsByLeader';

const useTeamLeader = () => {
  const { query, push } = useRouter();
  const { isLeaderPanel, isLeader } = useLeadership();
  const { me } = useMe();

  const { slug, teamId } = query as { slug: string; teamId: string };

  const { data } = useQuery<GetTeamsByLeader, GetTeamsByLeaderVariables>(
    GetTeamsByLeaderQuery,
    {
      context: { clientName: 'v4.b2b' },
      notifyOnNetworkStatusChange: true,
      skip: !isLeaderPanel,
      variables: {
        slug,
        leaderId: isLeader ? String(me?.userOrganization?.originalId) : null,
      },
    },
  );

  const teams = useMemo(
    () => data?.b2bWorkteams?.edges.map(node => node.node) || [],
    [data],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(() => {
    if (isLeaderPanel && !teamId) {
      if (teams.length) {
        const firstTeam = teams[0];
        push(
          `/org/${slug}/panel/lider/${firstTeam.originalId}/estadisticas/general/`,
        );
      }
    }
  }, [slug, teamId, teams]);

  const currentTeam = teams.find(team => team.originalId === teamId);

  return { teams, currentTeam, slug };
};

export default useTeamLeader;
